import React from 'react';
const Footer: React.FC = () => {
  return <footer style={{ padding: '20px', textAlign: 'center', backgroundColor: '#f9f9ff' }}>solutionhacks.gdg@gmail.com © 2024 GDGTMU SolutionHacks</footer>;
};
export default Footer;
